export const myCollectionsLightTheme = {
  '--my-collections-bgc-1': 'transparent',
  '--my-collections-font-c-1': '#333',
  '--my-collections-font-c-2': '#999',
  '--my-collections-font-c-3': '#65d5ff',
  '--my-collections-font-c-4': '#666',
  '--my-collections-border-c-1': '#3b3e49',
  '--my-collections-shadow-c-1': 'transparent',
}
export const myCollectionsDarkTheme = {
  '--my-collections-bgc-1': '#23262f',
  '--my-collections-font-c-1': '#fff',
  '--my-collections-font-c-2': '#fff',
  '--my-collections-font-c-3': '#65d5ff',
  '--my-collections-font-c-4': '#9fa7b3',
  '--my-collections-border-c-1': '#3b3e49',
  '--my-collections-shadow-c-1': '0 2px 0 rgb(0 0 0 / 2%)',
}
